var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconanalyticsprintReport24 = function SvgIconanalyticsprintReport24(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Analytics/icon.analytics.print_report_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Analytics/icon.analytics.print_report_24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#09BE86",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 1,
    y: 7,
    width: 22,
    height: 11,
    rx: 2.44444442
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#09BE86",
    cx: 5,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,13.5 L18.5,22.7777778 C18.5,22.9772139 18.4191625,23.1577695 18.288466,23.288466 C18.1577695,23.4191625 17.9772139,23.5 17.7777778,23.5 L17.7777778,23.5 L6.22222221,23.5 C6.02278605,23.5 5.8422305,23.4191625 5.71153399,23.288466 C5.58083747,23.1577695 5.5,22.9772139 5.5,22.7777778 L5.5,22.7777778 L5.5,13.5 L18.5,13.5 Z",
    id: "Rectangle-Copy",
    stroke: "#09BE86",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 15,
    x2: 15.5,
    y2: 18,
    id: "Line",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 16,
    id: "Line-Copy",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 15,
    x2: 8.5,
    y2: 19.5,
    id: "Line-Copy-2",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,6 L6,2.22222222 C6,1.54720753 6.54720753,1 7.22222222,1 L16.7777778,1 C17.4527925,1 18,1.54720753 18,2.22222222 L18,6 L18,6",
    id: "Path-11",
    stroke: "#09BE86",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconanalyticsprintReport24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.analytics.print_report_24.a500706472e6099151944dddb1bf22c8.svg";